import {
  Box,
  Dialog as MuiDialog,
  Drawer as MuiDrawer,
  styled,
} from '@mui/material';

export const Dialog = styled(MuiDialog)(({ theme }) => ({
  // Above any panel that raises itself over MUI's default modal layer -- the
  // resume-builder analysis drawer sits at 1301. At the default 1300 this
  // dialog painted *under* that drawer's backdrop, so a click on Buy landed on
  // the backdrop and closed the drawer instead of buying anything. The Drawer
  // variant below already claims 1400 for the same reason; this is the layer
  // the top-up surface owns, and it is mounted at the app root so nothing it
  // covers is ever its own parent.
  zIndex: 1400,
  '& .MuiDialog-paper': {
    borderRadius: '16px',
    maxWidth: '420px',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    backgroundImage: 'none',
  },
}));

export const Drawer = styled(MuiDrawer)(({ theme }) => ({
  zIndex: 1400,
  '& .MuiDrawer-paper': {
    zIndex: 1400,
    borderRadius: '22px 22px 0 0',
    backgroundColor: theme.palette.background.paper,
    backgroundImage: 'none',
  },
}));

/** The drawer's grab handle — mobile only, per the design's bottom sheet. */

/** The drawer's grab handle — mobile only, per the design's bottom sheet. */
export const SheetGrabber = styled(Box)(({ theme }) => ({
  width: 40,
  height: 4,
  borderRadius: 9,
  margin: '9px auto 0',
  backgroundColor: '#dbe2ea',
  ...theme.applyStyles('dark', { backgroundColor: theme.palette.divider }),
}));
